export default {
	state: {
		valorResgateSolicitado: {}
	},
	getters: {
		"valorResgateSolicitado": state => state.valorResgateSolicitado
	},
	mutations: {
		setValorResgateSolicitado(state, payload) {
			state.valorResgateSolicitado = payload
		}
	},
	actions: {
		atualizarEstadoValorResgateSolicitado({ commit }, payload) {
			commit('setValorResgateSolicitado', payload)
		}
	}
};